import { cloneDeep } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { StubsService } from '../Services/stubs.service';
import { DefaultStub } from '../models/stub.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedData } from '../shared-data/shared-object.service';
import { EditStub } from '../models/stub.model';
import { PipeTransform, Pipe } from '@angular/core';
import { CONTENT_TYPES, IDENTIFIERS } from '../common/constants/defines';
import 'json-editor';
import { AuthenticationService } from '../Services/authentication.service'


@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  transform(value, args: string[]): any {
    let keys = [];
    for (let key in value) {
      keys.push({ key: key, value: value[key] });
    }
    return keys;
  }
}

@Component({
  selector: 'app-stubs-data',
  templateUrl: './stubs-data-add.component.html',
  styleUrls: ['./stubs-data-add.component.css']
})
export class StubsDataComponent implements OnInit {

  constructor(private _stubsService: StubsService, private _activatedRoute: ActivatedRoute,
    private _router: Router, private _sharedData: SharedData, private authService: AuthenticationService) { }

  public defaultData: DefaultStub;
  public serviceName: string;
  // public editor: any;
  public statusCodes: any[] = [];
  public selectedStatusCode: string;
  public identifiers_length: any;
  public showSuccesOverLay: boolean = false;
  public automationSuccesOverLay: boolean = false;
  public successOverLayMessage: string = '';
  public showFailOverLay: boolean = false;
  public showInvalidOverlay: boolean = false;
  public messageForError: string = '';
  public identifiers = [];
  public errorMessages: string[] = [];
  public showCookie: boolean = false;
  // public cookie: any;
  private isEdit: boolean;
  private stubId;

  private stubs: EditStub[];

  public currentStub: any = {}

  public numberOfMiliSeconds: string = '';

  public editor: any = {}

  public stubName: string;

  public service: any = {};

  public cookiesDataList: any = [];
  public showError = false;

  public lastEditDate;
  /** headers list */
  public headersList: { key: string, value: string }[] = [];

  public contentTypes = CONTENT_TYPES;
  public contentTypesName = IDENTIFIERS.contentType;
  public selectedContentType = this.contentTypes[0].contentType;

  public stubsDataTypes = ['DEV', 'TEST'];

  public stubsDataSelectedType = '';

  public customBody;

  public replaceFlag = true;

  public lastEditBy;

  public lastUpdateDate;

  ngOnInit() {
    this.serviceName = this._activatedRoute.snapshot.params['serviceName'];
    this.stubId = this._activatedRoute.snapshot.params['id'];
    if (this.stubId) {
      this.isEdit = true;
    }

    if (this.serviceName) {

      this.setCurrentServiceData();
    } else {

      this._router.navigateByUrl('/stubsoverview/' + this.serviceName);
    }
  }

  setCurrentServiceData() {

    this._stubsService.getServiceByName(this.serviceName)
      .subscribe(serviceData => {
        this.service = serviceData;
        this.identifiers = this.service.identifiers || [];
        for (let i = 0; i < this.service.identifiers.length; i++) {

          this.identifiers[i][this.service.identifiers[i].name] = '';
        }
        for (let i = 0; i < this.service.serviceTemplates.length; i++) {
          this.statusCodes.push(this.service.serviceTemplates[i].code);
        }
        if (this.isEdit) {
          this.stubDataEdit();
        } else {

          this.selectedStatusCode = '';
        }
      });
  }

  public onChange(newVal): void {
    this.stubDataAdd(newVal);
  }

  private stubDataEdit() {
    this._stubsService.getStubById(this.serviceName, this.stubId).subscribe(
      currentStub => {
        this.currentStub = currentStub;
        let statusCode = this.currentStub.respCode;
        this.selectedStatusCode = statusCode;
        this.cookiesDataList = this.currentStub.cookiesData;
        this.headersList = this.currentStub.headers || [];
        this.stubsDataSelectedType = this.currentStub.stubsDataSelectedType || '';
        this.numberOfMiliSeconds = this.currentStub && this.currentStub.delay ? this.currentStub.delay.toString() : '';

        if (this.headersList.length) {
          this.selectedContentType = this.headersList[0].value;
        }
        if (this.selectedContentType == this.contentTypes[1].contentType) {
          this.replaceFlag = false;
          this.customBody = this.currentStub.data;
        }

        this.currentStub.lastEditDate ? this.lastEditDate = this.currentStub.lastEditDate : '';

        if (this.currentStub.lastEditBy) {
          this._stubsService.getUserById(this.currentStub.lastEditBy).subscribe((response) => {
            this.lastEditBy = response.user.email;
          })
          this.lastEditDate = this.currentStub;
        }
        if (this.currentStub.hasOwnProperty("replaceFlag")) {
          this.replaceFlag = this.currentStub.replaceFlag ? true : false;
        } else {
          this.replaceFlag = true;
        }
        //override identifiers
        for (let i = 0; i < this.identifiers.length; i++) {
          for (let key in this.currentStub.identifiers) {
            if (this.identifiers[i].name == key) {
              if (this.identifiers[i].cookieDataType == 'pairs') {
                for (var firstKey in this.currentStub.identifiers[key]) {
                  this.identifiers[i][key] = this.currentStub.identifiers[key];
                  break;
                }
              } else {
                this.identifiers[i][key] = this.currentStub.identifiers[key];
              }
            }
          }
        }
        // this.identifiers = this.currentStub.identifiers;
        this._stubsService.getServiceDefaultData(this.serviceName, statusCode).subscribe(
          service => {
            if (!this.currentStub.headers) {
              this.headersList = service.headers;
            }
            if (this.selectedContentType != this.contentTypes[1].contentType) {
              this.editor = new JSONEditor(document.getElementById('editor'), {
                ajax: true,
                schema: service.data.schema,
                startval: this.currentStub.data,
                theme: 'foundation5',
                iconlib: "fontawesome4"
              });
            }

          }
        )
      }
    )
  }

  public stubForAutomation() {

    if (this.currentStub && this.currentStub.stubName) {

      return this.currentStub.stubName.indexOf('AUTOMATED || DEFAULT_STUB') >= 0;
    }

    return false;
  }

  public checkForAutomationStub() {

    if (this.stubForAutomation()) {

      this.successOverLayMessage = `It seems that this stub is dedicated for automation, please consider:
      <br/><b>1) You must put the entire response for the service in the JSON editor below</b>
      <br/><b>2) Replacement flag checkbox will be not available</b>`;

      this.automationSuccesOverLay = true;
    }
  }

  private stubDataAdd(newVal) {
    // this._stubsService.getStubsTemplateData(this.serviceName).subscribe();
    this.cookiesDataList = this.getCookiesDataByRespCode(newVal);
    this._stubsService.getServiceDefaultData(this.serviceName, newVal)
      .subscribe(services => {
        this.defaultData = services.data;
        this.headersList = services.headers || [];
        //default content-type comes in first
        if (this.headersList.length) {
          this.selectedContentType = this.headersList[0].value;
        }

        if (document.getElementById('editor') && document.getElementById('editor').children[0]) {

          document.getElementById('editor').children[0].remove();
        }

        // Initialize the editor
        this.editor = new JSONEditor(document.getElementById('editor'), {
          ajax: true,
          schema: this.defaultData.schema,
          startval: this.defaultData.defaultBody,
          theme: 'foundation5',
          iconlib: "fontawesome4"
        });
      },
        error => console.log(error));
  }

  public onChangeContentType($event) {
    let tempHeader = { key: this.contentTypesName, value: $event };
    this.headersList[0] = tempHeader;
    this.selectedContentType = $event;
  }

  public submitStubData(submitDataForAutomation) {

    if (this.stubForAutomation() && !submitDataForAutomation) {

      this.successOverLayMessage = `Do you confirm that you already setted the entire response for this automation default stub?`;

      this.replaceFlag = false;

      this.automationSuccesOverLay = true;

      return;
    } else if (this.stubForAutomation()) {

      this.replaceFlag = false;
    }

    if (!this.isValidDelay()) {

      alert('delay must be a number');

      return;
    }

    if (!this.currentStub.stubName || !this.stubsDataSelectedType) {

      this.messageForError = `Invalid stubs data! Please make sure that you fill the form correctly`;

      this.showInvalidOverlay = true;

      return;
    }

    this.currentStub.stubName = this.currentStub.stubName.trim();

    const identifiers = cloneDeep(this.identifiers);
    for (let i = 0; i < identifiers.length; i++) {
      delete identifiers[i].cookieDataType;
      delete identifiers[i].cookieEncodingType;
      delete identifiers[i].cookieIdentifierKey;
      delete identifiers[i].name;
      delete identifiers[i].queryType;
      delete identifiers[i].value;
    }

    let identifiersObj = {};

    for (let i = 0; i < identifiers.length; i++) {
      for (var key in identifiers[i]) {
        if (identifiers[i][key]) {
          identifiersObj[key] = identifiers[i][key] ? (identifiers[i][key]).trim() : identifiers[i][key];
        } else if (this.stubForAutomation()) {

          this.messageForError = `<b>Idenitifier "${key}" for automation default stub cannot be left empty</b>`;

          this.showInvalidOverlay = true;

          return;
        }
      }
    }
    let timeNow = new Date().getTime();
    let currentUserId = this.authService.getCurrentUser()._id;

    var data;
    if (this.selectedContentType == this.contentTypes[1].contentType) {
      this.replaceFlag = this.contentTypes[1].handlebarsTemplate;
      data = this.customBody;
    } else {
      data = this.editor.getValue();
    }

    var payload = {
      "stubName": this.currentStub.stubName,
      "respCode": this.selectedStatusCode,
      "identifiers": identifiersObj,
      "data": data,
      "cookiesData": this.cookiesDataList,
      "headers": this.headersList,
      "replaceFlag": this.replaceFlag,
      "lastUpdateDate": timeNow,
      "lastUpdatedBy": currentUserId,
      "stubsDataSelectedType": this.stubsDataSelectedType,
      delay: this.numberOfMiliSeconds && !isNaN(Number(this.numberOfMiliSeconds)) ? Number(this.numberOfMiliSeconds) : ''
    };

    if (this.isEdit) {
      payload['_id'] = this.currentStub._id;
      this._stubsService.updateStubData(this.serviceName, payload).
        subscribe(response => {
          if (response.status == 200) {
            this.showSuccesOverLay = true;
            this.successOverLayMessage = 'Stub data saved successfully';
          } else {
            this.showFailOverLay = true;
          }
        },
          error => this.showFailOverLay = true
        );
    } else {
      this._stubsService.putStubsData(this.serviceName, payload).
        subscribe(response => {
          if (response.status == 200) {
            this.showSuccesOverLay = true;
            this.successOverLayMessage = 'Stub data saved successfully';
          } else {
            this.showFailOverLay = true;
          }
        },
          error => this.showFailOverLay = true
        );

    }

  }

  public closeOverLays(overlayType, submitData) {
    if (overlayType == 'success') {
      this._router.navigate(['/stubsoverview', this.serviceName]);
    }
    this.showFailOverLay = false;
    this.showSuccesOverLay = false;
    this.showInvalidOverlay = false;
    this.automationSuccesOverLay = false;

    if (submitData) {

      this.submitStubData(submitData);
    }
  }
  public getProp(index, name, key?, isEdit?) {

    if (isEdit) {
      if (!this.currentStub.identifiers) return;
      if (key) {
        return this.currentStub.identifiers[name][key];
      }
      return this.currentStub.identifiers[name];
    } else {
      if (!this.identifiers) return;
      if (key) {
        return this.identifiers[index][name][key] || '';
      } else {
        return this.identifiers[index][name];
      }
    }


  }
  public setprop(property, index, name, key?) {
    if (key) {
      let obj = {};
      obj[key] = property;
      this.identifiers[index][name] = obj;
    } else {
      this.identifiers[index][name] = property;
    }
  }

  public setdelay(value) {

    value = value.toString();

    this.numberOfMiliSeconds = value.toString().trim();
  }

  public isValidDelay() {

    if (this.numberOfMiliSeconds && isNaN(Number(this.numberOfMiliSeconds))) {

      return false;
    }

    return true;
  }

  public getdelay() {

    return this.numberOfMiliSeconds;
  }
  private getCookiesDataByRespCode(respCode) {
    let cookiesData = {

    };
    for (let i = 0; i < this.service.serviceTemplates.length; i++) {
      if (this.service.serviceTemplates[i].code == respCode) {
        if (this.service.serviceTemplates[i].cookies && this.service.serviceTemplates[i].cookies.length > 0) {
          for (let j = 0; j < this.service.serviceTemplates[i].cookies.length; j++) {
            // this.service.serviceTemplates[i].cookies[j].data = JSON.stringify(this.service.serviceTemplates[i].cookies[j].data);
            cookiesData[this.service.serviceTemplates[i].cookies[j].name] = this.service.serviceTemplates[i].cookies[j].data;
          }
          return cookiesData;
        } else {
          return null;
        }
      }
    }
  }

  public setValue(cookieKey, entryKey, event) {
    if (entryKey) {
      let obj = this.cookiesDataList[cookieKey];
      obj[entryKey] = event
      this.cookiesDataList[cookieKey] = obj;
    } else {
      this.cookiesDataList[cookieKey] = event;
    }
  }

  public isCookieTypeString(value: any) {
    return typeof value === 'string'
  }

}


// WEBPACK FOOTER //
// ./src/app/stubs-data-add/stubs-data-add.component.ts